import React, { useEffect, useState } from "react";
import { COLORS } from "../../constants/colors";

const ScrollProgress = () => {
  const [scrollWidth, setScrollWidth] = useState(0);

  const handleScroll = () => {
    const scrollTop = window.scrollY; // how much scrolled
    const docHeight = document.body.scrollHeight - window.innerHeight; // total scrollable height
    const scrollPercent = (scrollTop / docHeight) * 100; // 0 - 100%
    setScrollWidth(scrollPercent);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="w-full h-1 fixed top-[80px] left-0 z-20">
      <div
        className={`h-full bg-[${COLORS.BgSecondary}] transition-all duration-200`}
        style={{ width: `${scrollWidth}%` }}
      ></div>
    </div>
  );
};

export default ScrollProgress;